import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, HorizontalFlex, PadContainer, Input } from 'smartsuite-ui';
import DataPanel from './DataPanel';

function processConfigs(configuration) {
    let result = {};
    if (configuration.views?.length) {
        configuration.views.forEach((view) => {
            if (view.widgets?.length) {
                view.widgets
                    .map((x) => x.metricRequests)
                    .flat()
                    .filter((x) => x)
                    .forEach((request) => {
                        result = {
                            ...result,
                            [request.metricSourceKey]: {
                                metrics: [
                                    ...(result[request.metricSourceKey]
                                        ?.metrics ?? []),
                                    ...(request.metrics ?? []),
                                ],
                                groupBy: [
                                    ...(result[request.metricSourceKey]
                                        ?.groupBy ?? []),
                                    ...(request.groupBy ?? []),
                                ],
                            },
                        };
                    });
            }
        });
    }

    return result;
}

function processAllConfigs(dashboardconfigs) {
    let result = {};
    dashboardconfigs.forEach(({ configuration }) => {
        if (configuration.views?.length) {
            configuration.views.forEach((view) => {
                if (view.widgets?.length) {
                    view.widgets
                        .map((x) => x.metricRequests)
                        .flat()
                        .filter((x) => x)
                        .forEach((request) => {
                            result = {
                                ...result,
                                [request.metricSourceKey]: {
                                    metrics: [
                                        ...(result[request.metricSourceKey]
                                            ?.metrics ?? []),
                                        ...(request.metrics ?? []),
                                    ],
                                    groupBy: [
                                        ...(result[request.metricSourceKey]
                                            ?.groupBy ?? []),
                                        ...(request.groupBy ?? []),
                                    ],
                                },
                            };
                        });
                }
            });
        }
    });

    return result;
}

export default function GroupByMetricSource(props) {
    const [expandAll, setExpandAll] = useState(false);
    const metricSources =
        window.location.pathname === '/Dashboard/Audit/'
            ? processAllConfigs(props.dashboardConfiguration)
            : processConfigs(props.dashboardConfiguration);

    const [inputText, setInputText] = useState('');

    Object.keys(metricSources).forEach((key) => {
        if (metricSources[key].metrics.length < 1) delete metricSources[key];
    });

    function doesFilterMatch(metricSourceKey) {
        return (
            !inputText ||
            metricSourceKey.toLowerCase().includes(inputText.toLowerCase())
        );
    }

    return (
        <div className="bymetric">
            <HorizontalFlex cssClassModifiers={['space-between']}>
                <div className="dummy" />
                <div className="search-container">
                    <Input
                        value={inputText}
                        label="Search"
                        isClearable={true}
                        onChange={(newText) =>
                            setInputText(newText.target.value)
                        }
                    />
                </div>
            </HorizontalFlex>
            <HorizontalFlex cssClassModifiers={['space-between']}>
                <h1>{`Total Count: ${
                    Object.keys(metricSources).sort().filter(doesFilterMatch)
                        .length
                }`}</h1>
                <HorizontalFlex>
                    <Button
                        onClick={() => setExpandAll(true)}
                        disabled={expandAll}
                    >
                        Expand All
                    </Button>
                    <PadContainer cssClassModifiers={['pad-small']} />
                    <Button
                        onClick={() => setExpandAll(false)}
                        disabled={!expandAll}
                    >
                        Collapse All
                    </Button>
                </HorizontalFlex>
            </HorizontalFlex>
            <div className="content">
                {Object.keys(metricSources)
                    .sort()
                    .filter(doesFilterMatch)
                    .map((metricSourceKey) => (
                        <>
                            <PadContainer cssClassModifiers={['pad-medium']} />
                            <DataPanel
                                metricSourceKey={metricSourceKey}
                                metricSource={metricSources[metricSourceKey]}
                                expandAll={expandAll}
                            />
                        </>
                    ))}
            </div>
        </div>
    );
}

GroupByMetricSource.propTypes = {
    dashboardConfiguration: PropTypes.instanceOf(Object).isRequired,
};
